import axios from 'axios';
import apiConfig from '../api.config';

export default function getGuestlinkSmtpAuthConfig({ hotelId }) {
  const {
    host,
    URIs: { guestlinkSmtpAuthConfig },
  } = apiConfig;

  const uri = `${host}${guestlinkSmtpAuthConfig.replace(':hotelId', hotelId)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
